export default {
	dateFormat: "dd/mm/yy",
	firstDayOfWeek: 1,
	emptyMessage: "",
};
